module.exports = __webpack_public_path__ + "assets/img/calculator-simple.c1d8f086.svg";